import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DrivingSchoolInformation.module.scss'
import { drivingPhoneNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const PhoneNumber = ({ t, validatePhoneNumber, phoneNumberError, phoneNumberValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const phoneNumber = useSelector((state) => state.drivingSchool.drivingSchoolInformation.phoneNumber)

  const handlePhoneNumber = (e) => {
    try {
      var x = e.currentTarget.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      let phoneNumberParsed = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
      dispatch(drivingPhoneNumberAction(phoneNumberParsed))
      validatePhoneNumber(phoneNumberParsed)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validatePhoneNumber(phoneNumber)
  }

  return (
    <div
      className={[
        phoneNumberValid === true
          ? phoneNumber === ''
            ? ''
            : 'form-group has-success'
          : phoneNumberValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="ContactPhoneNumber">
        {t('driving_school_information.phone_number')}
      </label>
      <input
        type="text"
        id="ContactPhoneNumber"
        className="form-control"
        value={phoneNumber}
        onChange={handlePhoneNumber}
        onFocus={() => SetIsFocussed(true)}
        onBlur={handleOnBlur}
        autoComplete="off"
        maxLength="12"
      />
      {phoneNumberValid === true ? (
        phoneNumber === '' ? (
          ''
        ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
      ) : phoneNumberValid === false ? (
        <React.Fragment>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(phoneNumberError)}</div>
        </React.Fragment>
      ) : (
            ''
          )}
    </div>
  )
}

export default withTranslation('common')(PhoneNumber)
